<div class="section-title">
  <div class="section-title__text">
    <h2 class="section-title__title" [attr.id]="headingId()">{{ title() }}</h2>
    @if (subtitle().trim()) {
      <p class="section-title__subtitle">{{ subtitle() }}</p>
    }
  </div>
  <div class="section-title__right">
    <ng-content select="[right]" />
  </div>
</div>
